import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TechHero from "../components/TechHero";
import useSEO from "../hooks/useSEO";
import { trackEvent } from "../hooks/useGoogleAnalytics";
import { useCalendlyPopup } from "../hooks/useCalendlyPopup";
import { CALENDLY_CONFIG } from "../config/constants";

export default function BookConsultation() {
  const [bookingStatus, setBookingStatus] = useState("");
  const { openCalendlyPopup } = useCalendlyPopup();
  const CALENDLY_URL = CALENDLY_CONFIG.getUrl();

  useSEO(
    "Book Free Consultation | ZS NEXATECH",
    "Schedule a free product consultation with ZS NEXATECH. Discuss your scope, timeline, and execution roadmap.",
    "book consultation, product discovery call, software consultation",
    "https://www.zsnexatech.com/book-consultation"
  );

  useEffect(() => {
    trackEvent("consultation_booking_page_view", { source: "book_consultation_route" });

    const handleCalendlyMessage = (event) => {
      if (event.origin !== "https://calendly.com") {
        return;
      }

      const calendlyEvent = event.data?.event;
      if (typeof calendlyEvent !== "string" || !calendlyEvent.startsWith("calendly.")) {
        return;
      }

      trackEvent("calendly_event", { calendly_event: calendlyEvent });

      if (calendlyEvent === "calendly.event_scheduled") {
        setBookingStatus("✅ Consultation booked successfully. We'll connect with you soon.");
        trackEvent("consultation_booked", {
          source: "calendly_popup_widget",
        });
      }
    };

    window.addEventListener("message", handleCalendlyMessage);
    return () => {
      window.removeEventListener("message", handleCalendlyMessage);
    };
  }, []);

  const handleOpenCalendlyPopup = () => {
    trackEvent("consultation_booking_popup_click", { source: "book_consultation_route" });
    openCalendlyPopup(CALENDLY_URL);
  };

  const handleOpenCalendlyDirect = () => {
    trackEvent("consultation_booking_direct_link_click", { source: "book_consultation_route" });
  };

  return (
    <div className="space-y-10">
      <TechHero
        kicker="Book Consultation"
        title="Pick a time for your free strategy call"
        subtitle="Share your goals and get practical guidance on scope, timeline, architecture, and delivery plan."
        ctaText="Book Now"
        ctaLink="/"
      />

      <section className="premium-panel glass-panel animated-border space-y-5">
        <div>
          <h2 className="text-2xl font-bold text-white">Schedule your consultation</h2>
          <p className="mt-2 text-gray-100">
            Choose a time that works best for you. We will open the real Calendly booking page in a new tab.
          </p>
        </div>

        {bookingStatus ? (
          <div className="rounded-xl border border-emerald-300/60 bg-emerald-500/20 px-4 py-3 text-sm font-semibold text-emerald-100">
            {bookingStatus}
          </div>
        ) : null}

        <div id="book-now" className="card rounded-2xl border border-white/30 bg-linear-to-r from-amber-500/10 to-orange-500/10 backdrop-blur-lg p-6 md:p-8">
          <div className="flex flex-col items-center justify-center gap-4 py-8">
            <h3 className="text-xl font-semibold text-white">Ready to discuss your project?</h3>
            <p className="text-center text-gray-200 max-w-md">
              Click below to open Calendly and pick your preferred time slot.
            </p>
            <button
              onClick={handleOpenCalendlyPopup}
              className="btn-gold consultation-booking"
            >
              Schedule Consultation
            </button>
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noreferrer"
            className="link-gold"
            onClick={handleOpenCalendlyDirect}
          >
            Open in new tab
          </a>
          <Link to="/contact" className="link-gold">
            Prefer email or WhatsApp?
          </Link>
        </div>
      </section>
    </div>
  );
}
